import ApplicationAdapter from '../application';

export default class Base extends ApplicationAdapter {
  namespace = 'cron/v4';

  pathForType() {
    return super
      .pathForType(...arguments)
      .replace('cron/', '')
      .toLowerCase();
  }
}
